/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IContactDetails } from 'app/shared/model/contact-details.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { EntityType } from 'app/shared/model/enumerations/entity-type.model';

export interface IHealthCamp {
  id?: string;
  name?: string;
  code?: string;
  sponsoredBy?: string | null;
  description?: string | null;
  startDate?: number;
  endDate?: number;
  location?: string;
  organizerType?: keyof typeof EntityType;
  organizerId?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  contactDetails?: IContactDetails | null;
  type?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IHealthCamp> = {
  active: false,
};
